import { render, staticRenderFns } from "./MicAnimation.vue?vue&type=template&id=1ee798ee"
var script = {}
import style0 from "./MicAnimation.vue?vue&type=style&index=0&id=1ee798ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports